import Evidenza from 'components/atomic/Evidenza'

const HitCorrelati = ({ hit }) => {
  return <Evidenza item={{ ...hit, nome: hit.titolo }} />
}

export default HitCorrelati
